import { z } from 'zod';
import { $getFiltersRequestType } from '@shared/types';

const $EmploymentType = z.object({
  id: z.number(),
  name: z.string(),
});

export type GetEmploymentTypesRequest = z.infer<
  typeof $GetEmploymentTypesRequest
>;
export const $GetEmploymentTypesRequest = $getFiltersRequestType(z.object({}));

export const $GetEmploymentTypesResponse = z.array($EmploymentType);

export type GetEmploymentTypesResponse = z.infer<
  typeof $GetEmploymentTypesResponse
>;
